// extracted by mini-css-extract-plugin
export default {"container":"style_container__Os9TE","containerLeft":"style_containerLeft__hwpGE","containerRight":"style_containerRight__sr7f3"};